module.exports = __webpack_public_path__ + "media/images/lb/935-5a9e7a3173fba8281575167ca1d0afbe.svg";